<template>
  <v-layout wrap justify-center>
    <ServerError v-if="ServerError" />
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="blue"
      spinner="mini-spinner"
    />
    <v-snackbar
      :timeout="3000"
      :value="true"
      right
      color="red"
      v-model="showsnackbar"
    >
      <span style="font-size: 20px"> {{ msg }}</span>
    </v-snackbar>
    <v-flex xs12 pt-6>
      <v-layout wrap justify-start fill-height>
        <v-flex xs12 md6 align-self-start pa-2>
          <v-card align="center" flat>
            <v-layout wrap justify-space-between>
              <v-flex
                xs12
                pb-2
                pb-md-0
                class="text-left nsbold"
                style="font-weight: 700; font-size: 20px"
                >Trip Details
                <span style="font-size: 16px"> - {{ $route.query.tname }}</span>
              </v-flex>
              <!-- <v-flex
                xs12
                sm3
                md4
                lg4
                pb-2
                pb-md-0
                align-self-center
                class="text-left nsregular"
              >
                <v-text-field
                  v-model="keyword"
                  dense
                  class="rounded-xl"
                  label="Search"
                  outlined
                  hide-details
                  clearable
                ></v-text-field>
              </v-flex> -->
            </v-layout>

            <v-layout wrap>
              <v-flex xs12 align-self-center>
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">Pickup/Drop Point</th>
                        <th class="text-left">Bus</th>
                        <th class="text-left">Student</th>
                        <th class="text-left">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        class="text-left regular"
                        v-for="(item, i) in mappedList"
                        :key="i"
                      >
                        <td>
                          <span v-if="item.name">
                            {{ item.name }}
                          </span>
                        </td>
                        <td>
                          <span v-if="item.tripId">
                            <span v-if="item.tripId.busid">
                              {{ item.tripId.busid.name }}
                            </span> 
                            
                            <span v-if="item.tripId" style="font-size:12px">
                              [{{ item.tripId.name }}]
                            </span>
                          </span>

                        </td>
                        <td>
                           <span
                            class="vhover"
                            v-if="item.studentId"
                            style="cursor: pointer"
                            @click="
                              $router.push('/profile?id=' + item.studentId._id)
                            "
                          >
                            {{ item.studentId.name }}
                          </span>
                        </td>

                        <td>
                          <v-layout wrap>
                            <!-- <v-flex xs6 align-self-center v-if="item">
                              <span
                                ><v-icon
                                  style="cursor: pointer"
                                  @click="editCurrent(item)"
                                  >mdi-circle-edit-outline</v-icon
                                ></span
                              >
                            </v-flex> -->
                            <v-flex xs6 align-self-center>
                              <span
                                ><v-icon
                                title="Delete"
                                  style="cursor: pointer"
                                  @click="(dialoge = true), (curId = item._id)"
                                  >mdi-delete-outline</v-icon
                                ></span
                              >
                            </v-flex>
                          </v-layout>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-flex>
            </v-layout>

            <v-layout wrap>
              <v-flex xs12 pt-4>
                <v-pagination
                  small
                  color="#766BC0"
                  v-model="page"
                  :length="Pagelength"
                >
                </v-pagination>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>

        <v-flex xs12 md6 align-self-start v-if="mappedList">
          <Map :storage="mappedList" />
        </v-flex>
      </v-layout>

      <v-dialog width="450px" v-model="dialoge">
        <v-card>
          <v-toolbar dark color="#766BC0" dense flat class="body-2">
            <v-toolbar-title> Confirm Delete </v-toolbar-title>
          </v-toolbar>
          <v-card-text class="pa-4 black--text"
            >Are you sure you want to delete this record?
          </v-card-text>
          <v-card-actions class="pt-3">
            <v-spacer></v-spacer>
            <v-btn
              color="grey"
              text
              class="body-2 font-weight-bold"
              @click="dialoge = false"
              >Cancel</v-btn
            >
            <v-btn
              color="#766BC0"
              class="body-2 font-weight-bold"
              outlined
              @click="deleteMap()"
              >OK</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog max-width="70%" v-model="editdialogue">
        <v-card>
          <v-toolbar dark color="#766BC0" dense flat class="body-2">
            <v-toolbar-title> Edit Details </v-toolbar-title>
          </v-toolbar>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-layout wrap pa-4>
              <v-flex xs12 sm6 align-self-center pa-2>
                <v-text-field
                  dense
                  hide-details
                  outlined
                  required
                  label="Trip Name"
                  v-model="curItem.name"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 align-self-center pa-2>
                <v-select
                  dense
                  hide-details
                  outlined
                  required
                  :item-text="(item) => item.name + ' - ' + item.type"
                  item-value="_id"
                  :items="sectionList"
                  label="Choose Section"
                  v-model="curItem.sectionId"
                ></v-select>
              </v-flex>

              <v-flex xs12 sm6 align-self-center pa-2>
                <v-select
                  dense
                  hide-details
                  outlined
                  required
                  item-text="name"
                  item-value="_id"
                  :items="routeList"
                  label="Choose Route"
                  v-model="curItem.routeId"
                ></v-select>
              </v-flex>

              <v-flex xs12 sm6 align-self-center pa-2>
                <v-select
                  dense
                  hide-details
                  outlined
                  readonly
                  required
                  item-text="name"
                  item-value="_id"
                  :items="busList"
                  label="Choose Bus"
                  v-model="curItem.busId"
                ></v-select>
              </v-flex>
            </v-layout>
            <v-card-actions class="pt-3">
              <v-spacer></v-spacer>
              <v-btn
                color="grey"
                text
                class="body-2 font-weight-bold"
                @click="editdialogue = false"
                >Cancel</v-btn
              >
              <v-btn
                :disabled="!valid"
                color="#766BC0"
                class="body-2 font-weight-bold"
                outlined
                @click="editBus()"
                >OK</v-btn
              >
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import Map from "./map";

export default {
  components: {
    Map,
  },
  data() {
    return {
      page: 1,
      Pagelength: 0,
      dialoge: false,
      editdialogue: false,
      showsnackbar: false,
      msg: null,
      appLoading: false,
      ServerError: false,
      valid: true,
      sectionData: {},
      curItem: {},
      sectionList: null,
      tripData: {},
      show2: true,
      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",
        phoneRules: [
          (v) => !!v || "phone is required",
          (v) =>
            (v && v.length <= 10) || "number must be less than 11 characters",
          (v) =>
            (v && v.length >= 10) ||
            "number must be greater than 10 characters",
          (v) => /^\d{10}$/.test(v) || "phone number must be a number",
        ],
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
      doManual: false,
      addDialog: false,
      busList: [],
      routeList: [],
      mappedList: null,
    };
  },
  beforeMount() {
    // this.getBus();
    // this.getRoutes();
    // this.getSections();
    this.getData();
  },
  watch: {
    page() {
      this.getData();
    },
    // keyword() {
    //   this.getData();
    // },
  },
  methods: {
    getBus() {
      this.appLoading = true;
      axios({
        method: "get",
        url: "/bus/admin/list",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.busList = response.data.data;
          } else {
            this.snackbar = true;
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    getSections() {
      this.appLoading = true;
      axios({
        method: "get",
        url: "/bus/admin/section/get/list",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.sectionList = response.data.data;
          } else {
            this.snackbar = true;
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    getRoutes() {
      this.appLoading = true;
      axios({
        method: "get",
        url: "/bus/admin/route/get/list",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            var routes = response.data.data.map((x) => x._id);
            this.routeList = routes;
          } else {
            this.snackbar = true;
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    editCurrent(item) {
      this.curItem = item;
      this.curItem.id = item._id;
      if (item.sectionId) {
        this.curItem.sectionId = item.sectionId._id;
      }
      if (item.routeId) {
        this.curItem.routeId = item.routeId._id;
      }
      if (item.busid) {
        this.curItem.busId = item.busid._id;
      }

      this.editdialogue = true;
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "get",
        url: "/bus/students/list",
        headers: {
          token: localStorage.getItem("token"),
        },
        params: {
          busId: this.$route.query.id,
          page: this.page,
          limit: 20,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.mappedList = response.data.data;

            this.Pagelength = Math.ceil(response.data.totalLength / 20);
          } else {
            this.snackbar = true;
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    //delete button
    deleteMap() {
      axios({
        url: "/bus/mapped/student/remove",
        method: "POST",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          id: this.curId,
        },
      })
        .then((response) => {
          this.delete = false;
          this.dialoge = false;
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Delete Sucessfully";
            // this.$router.go(-1)
            this.showsnackbar = true;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    validateInput() {
      if (
        !this.tripData.name ||
        !this.tripData.busId ||
        !this.tripData.sectionId ||
        !this.tripData.routeId
      ) {
        this.msg = "All fields are required*";
        this.showsnackbar = true;
        return;
      } else this.setTrip();
    },
    //add button
    setTrip() {
      {
        this.appLoading = true;
        axios({
          url: "/bus/admin/add/route/trip",
          method: "POST",
          headers: {
            token: localStorage.getItem("token"),
          },
          data: this.tripData,
        })
          .then((response) => {
            this.appLoading = false;

            if (response.data.status) {
              this.addDialog = false;
              this.msg = response.data.msg;
              this.showsnackbar = true;

              this.$refs.form.reset();
              this.$refs.form.resetValidation();
            } else {
              this.msg = response.data.msg;
              this.showsnackbar = true;
            }

            this.getData();
            this.tripData = {};
          })
          .catch((err) => {
            this.appLoading = false;
            this.ServerError = true;
            console.log(err);
          });
      }
    },
    //edit button
    editBus() {
      if (
        !this.curItem.name ||
        !this.curItem.sectionId ||
        !this.curItem.routeId ||
        !this.curItem.busId
      ) {
        this.msg = "All fields are required*";
        this.showsnackbar = true;
        return;
      } else {
        axios({
          url: "/bus/admin/edit/route/trip",
          method: "POST",
          headers: {
            token: localStorage.getItem("token"),
          },
          data: this.curItem,
        })
          .then((response) => {
            this.editdialogue = false;
            this.appLoading = false;
            if (response.data.status) {
              this.msg = response.data.msg;
              this.showsnackbar = true;
            } else {
              this.msg = response.data.msg;
              this.showsnackbar = true;
            }
            this.getData();
          })
          .catch((err) => {
            this.appLoading = false;
            this.ServerError = true;
            console.log(err);
          });
      }
    },
  },
};
</script>
<style scoped>
#map44 {
  height: 100%;
}
</style>
